import { Modal, ModalBody, Text, useTranslation } from "@familyzone/component-library";
import React from "react";

const SchoolCalendarSetupModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      size="sm"
      primaryCTALabel={t("Set School Time & Days")}
      onPrimaryCTAClick={onClose}
      headerText={t("Set up school time and days")}
    >
      <ModalBody>
        <Text mb="sp8" fontFamily="paragraphs" color="text.title">
          {t("Use this school calendar page to define school time and days. This is required before you can set up non-school days.")}
        </Text>
      </ModalBody>
    </Modal>
  );
};

export default SchoolCalendarSetupModal;
